const moment = require("moment");
const { region } = require("./formatCity");
exports.userModel = () => {
    return {
        endpoint: 'signup',
        loginId: "",
        currentPassword: "",
        password: "",
        rePassword: "",
        name: "",
        cell: "", // 본인인증문자 시 사용
        email: "",
        emailId: "",
        emailDomain: "",
        emailDomainType: "",
        birthdayType: "",
        signupPath: "",
        userType: "farmer",
        agreeAll: false,
        agreePolicy: false,// 개인정보 수집 이용동의
        agreeTerms: false, // 이용 약관동의
        marketing: false, // 마켓팅 동의
        checkAge: false, // 14세이상 동의
        appPush: false,
        address: {
            city: "",
            street: "",
            zipcode: "",
            siDo: "",
            guGun: "",
        },
        isAddressSearch: false,
        farm: {
            farmInfo_id: 0,
            crops1: "",
            areaSize1: "",
            crops2: "",
            areaSize2: "",
            organization: "",
            usedBayerProduct: "",
            purchaseArea: "",
            purchaseName: "",
            useYN: "Y"
        },
        userAdminAddInfo: {
            userSegment: "",
            isGiveSample: "",
            productSampleName: "",
            giveDate: "",
            mr: "",
            memo: "",
        },
        checkSms: false, // 인증받기를 시도했는지?
        checkedSms: false, // 인증받았는지?
        uploadFiles: []
    };
};

exports.userSampleModel = () => {
    return {
        endpoint: 'signup',
        loginId: "01067403262",
        password: "123456789!",
        rePassword: "123456789!",
        name: "테스트왕",
        cell: "01067403262", // 본인인증문자 시 사용
        email: "t62@predict.kr",
        emailId: "t62",
        emailDomain: "predict.kr",
        emailDomainType: "",
        birthdayType: "30",
        signupPath: "web",
        userType: "farmer",
        agreeAll: false,
        agreePolicy: true,// 개인정보 수집 이용동의
        agreeTerms: true, // 이용 약관동의
        marketing: false, // 마켓팅 동의
        checkAge: true, // 14세이상 동의
        appPush: false,
        address: {
            city: "서울 강남구 압구정동",
            street: "1234",
            zipcode: "1234",
            siDo: "경기",
            guGun: "강남구",
        },
        // isAddressSearch: false,
        isAddressSearch: true,
        farm: {
            farmInfo_id: 0,
            crops1: "배추",
            areaSize1: "200",
            crops2: "딸기",
            areaSize2: "400",
            organization: "그냥농부",
            usedBayerProduct: "루틴",
            purchaseArea: "구매처3",
            purchaseName: "농협",
            useYN: "Y"
        },
        userAdminAddInfo: {
            userSegment: "",
            isGiveSample: "",
            productSampleName: "",
            giveDate: "",
            mr: "",
            memo: "",
        },
        checkSms: false,
        checkedSms: false,
        uploadFiles: []
    };
};

exports.adminAddInfoModel = () => {
    return {
        userSegment: "",
        isGiveSample: "",
        productSampleName: "",
        giveDate: "",
        mr: "",
        memo: "",
        uploadFiles: null
    };
};

exports.staffModel = () => {
    return {
        endpoint: 'signup',
        loginId: "",
        name: "",
        email: "",
        birthdayType: "",
        gender: "",
        signupPath: "",
        userType: "admin",
        userPhotoImg: "",
        activated: true,
        address: {
            city: "",
            street: "",
            zipcode: "",
            siDo: "",
            guGun: "",
        },
        targetUserId: 0,
        adminInfo: {
            adminRegion1: "",
            adminRegion2: "",
            position: "",
            team: ""
        },
    };
};

exports.reqDataModel = () => {
    return {
        endpoint: "",
        fromDay: "",
        toDay: "",
        searchVal: "",
        activated: true,
        crops: "",
        siDo: "",
        guGun: "",
        user_id: 0,
        updUpk: 0
    }
}

